// Chrome / Firefox / Safari wordings, plus Vite's CSS-preload failure.
const CHUNK_LOAD =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i

export function isChunkLoadErrorMessage(message: string): boolean {
  return CHUNK_LOAD.test(message)
}

export function isChunkLoadError(error: unknown): boolean {
  return isChunkLoadErrorMessage(error instanceof Error ? error.message : String(error))
}

// A second failure this soon after a reload means the chunk is missing from the
// current deploy too — reloading again would loop.
export const CHUNK_RELOAD_WINDOW_MS = 60_000

export function canReloadAgain(lastReloadAt: number | null, now: number): boolean {
  return lastReloadAt === null || now - lastReloadAt >= CHUNK_RELOAD_WINDOW_MS
}
